import SectionTestimonials from "components/SectionTestimonials/SectionTestimonials";
import SectionHero from "components/SectionHero/SectionHero";
import WhyChooseUs from "components/WhyChooseUS/WhyChooseUs";
import { useEffect } from "react";
import RentalPolicies from "components/FAQs/FAQs";
import SectionAbout from "containers/PageAbout/SectionAbout";
import { useData } from "data/data-provider";
import SectionGridAllFleet from "./SectionGridAllFleet";
import { useLocation } from "react-router-dom";

function PageHome() {
  const { aboutUs, whyUs, testimonials, faqs, ourVehicles } = useData();
  const location = useLocation();

  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  useEffect(() => {
    const hash = location.hash;
    if (hash && !location.pathname.includes("loading")) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }, [location.hash, aboutUs, whyUs, testimonials, faqs, ourVehicles]);

  return (
    <>
      <div className="relative">
        <SectionHero />
        <div className="container relative" style={{ padding: "0px" }}>
          <div>
            {ourVehicles?.length > 0 && (
              <div
                className="container relative mt-16 sm:px-0"
                id="section-all-fleet"
              >
                <SectionGridAllFleet />
              </div>
            )}
            {aboutUs && (
              <div className="container mt-16 sm:px-0" id="section-about-us">
                <SectionAbout aboutUs={aboutUs} />
              </div>
            )}
            {(whyUs?.heading ||
              whyUs?.description ||
              whyUs?.image_url ||
              whyUs?.keypoints?.length > 0) && (
              <div className="container mt-16 sm:px-0" id="section-why-choose-us">
                <WhyChooseUs />
              </div>
            )}
            {(testimonials?.heading || testimonials?.keypoints?.length > 0) && (
              <div className="container mt-16 sm:px-0" id="section-testimonials">
                <SectionTestimonials uniqueClassName="PageAbout_" />
              </div>
            )}
          </div>
        </div>
        {(faqs?.heading ||
          faqs?.description ||
          faqs?.keypoints?.length > 0) && (
          <div className="container relative py-16" id="section-faqs">
            <RentalPolicies />
          </div>
        )}
      </div>
    </>
  );
}

export default PageHome;
